module.exports = __webpack_public_path__ + "static/media/win-fr.a3e6942a.png";